import { formatName } from "@api";
import type { ObjectId } from "@bbj-types/utils";

export const isOptionEqualToValue = <T extends { _id: ObjectId }>(userA: T, userB: T) => {
  return userA._id === userB._id;
};

export const getOptionLabel = <T extends { firstName?: string; lastName?: string }>(user: T) => formatName(user);
